import { type FC } from "react";
import { useTranslation } from "react-i18next";
import { useContentQuery, useContentsQuery } from "@/partner/entities/contents";
import { usePickerSearch } from "../model/usePickerSearch";
import { EntityPicker } from "./EntityPicker";

interface ContentPickerProps {
  value: string | null;
  onChange: (contentId: string | null) => void;
}

/**
 * Контент для CONTENT_CARD: поиск по списку контента платформы (первые 20
 * по запросу), подпись уже выбранного id берётся запросом Content, потому
 * что он может не попасть в первую страницу поиска.
 */
export const ContentPicker: FC<ContentPickerProps> = ({ value, onChange }) => {
  const { t } = useTranslation();
  const { setSearch, debouncedSearch } = usePickerSearch();
  const list = useContentsQuery({
    fetchPolicy: "cache-and-network",
    variables: {
      filter: { search: debouncedSearch || undefined },
      page: 0,
      rowsPerPage: 20,
    },
  });
  const selected = useContentQuery({
    variables: { id: value ?? "" },
    skip: !value,
  });

  return (
    <EntityPicker
      label={t("emailTemplates.blocks.content")}
      value={value}
      selectedLabel={selected.data?.content?.title}
      options={(list.data?.contents?.nodes ?? []).map((node) => ({
        value: node.id,
        label: node.title,
      }))}
      loading={list.loading}
      onSearch={setSearch}
      onChange={onChange}
      error={!value}
    />
  );
};
